// extracted by mini-css-extract-plugin
export default {"device":"IntelligentDevice_device__LCxw9"};